import React from 'react';
import { useHistory } from 'react-router';
import ErrorImg from '../../assets/error404.svg';

import './Error404.css';

const Error404 = () => {
  const history = useHistory();
  function goToHomePage() {
    history.push('/home');
  }
  function goToSupport() {
    history.push('/support');
  }

  return (
    <section className="error404-container">
      <div className="error-info">
        <h2>Ooops! Page not found</h2>
        <p>
          We suggest you go back to the the Homepage while we fix the problem.
        </p>
        <div className="error-buttons">
          <button
            type="button"
            className="btn btn--primary back_home"
            onClick={goToHomePage}
          >
            Back to Homepage
          </button>
          <button
            type="button"
            className="btn btn--outline support-error"
            onClick={goToSupport}
          >
            Visit Our Help Center
          </button>
        </div>
      </div>

      <div className="error-img">
        <img src={ErrorImg} alt="Haelo error page" className="hero__image" />
      </div>
    </section>
  );
};

export default Error404;
